import { SubmitCaseStudyReviewDto } from 'tdc-web-backend/case-studies-review/schemas';
import { CaseStudyContentDto } from 'tdc-web-backend/case-studies-content/schemas';
import { CaseStudy } from 'tdc-web-backend/case-studies/entities';
import { Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { APPBAR_HEIGHT } from '../../../../../../layout/dashboard-navigation/NavigationDashboard';
import useReferenceOne from '../../../../../../utils/hooks/crud-hooks/useReferenceOne';
import ConfirmCaseStudyReviewModal from '../ConfirmCaseStudyReviewModal';
import useGetOne from '../../../../../../utils/hooks/crud-hooks/useGetOne';
import ScoreInputs from './components/ScoreInputs';
import GeneralInputs from './components/GeneralInputs';

const CaseStudyReviewForm = () => {
  const [openModal, setIsOpenModal] = useState(false);
  const [storageData, setStorageData] = useState(null);

  const form = useForm<SubmitCaseStudyReviewDto>({
    defaultValues: {
      reviewer: {
        firstName: '',
        lastName: '',
        jobTitle: '',
        companyName: '',
        isAnonymous: false,
      },
      summarization: '',
      score: {
        qualityScore: undefined,
        qualityText: '',
        budgetScore: undefined,
        budgetText: '',
        scheduleScore: undefined,
        scheduleText: '',
        recommendationScore: undefined,
        recommendationText: '',
      },
      contactNumber: '',
    },
    mode: 'onChange',
  });
  const { caseStudyId, token } = useParams();

  const { data: caseStudy } = useGetOne<CaseStudy>({
    enabled: !!caseStudyId,
    resource: `case-studies/${caseStudyId}`,
  });

  const { data: caseStudyContent } = useReferenceOne<CaseStudyContentDto>({
    resource: `case-studies-content`,
    enabled: !!caseStudy?.data.content,
    id: caseStudy?.data.content as any,
  });

  useEffect(() => {
    try {
      const storageDataValue = localStorage.getItem('review');
      if (storageDataValue === null && storageData === null) {
        const reviewer = caseStudy?.data.review?.reviewer;
        form.reset({ ...form.getValues(), reviewer: { ...reviewer } });
      } else if (storageDataValue) {
        const storageDataParsed = JSON.parse(storageDataValue);
        form.reset({
          ...form.getValues(),
          score: { ...storageDataParsed.reviewData.score },
          summarization: storageDataParsed.reviewData.summarization,
          reviewer: storageDataParsed.reviewData.reviewer,
        });
        setStorageData(storageDataParsed);
        localStorage.removeItem('review');
      }
    } catch (error) {
      console.error('Error parsing review data from local storage', error);
    }
  }, [caseStudyContent]);

  return (
    <Stack mt={`${APPBAR_HEIGHT}px`} width="100%">
      <FormProvider {...form}>
        <form>
          <Stack
            px={{ xs: 0, md: '2%', bg: '4%', lg: '10%' }}
            direction={{ xs: 'column', md: 'row' }}
            width="100%"
            justifyContent="center"
          >
            <ScoreInputs data={caseStudyContent as CaseStudyContentDto} />
            <GeneralInputs
              caseStudyId={caseStudyId as string}
              token={token as string}
              contentId={caseStudyContent?.id as string}
            />
          </Stack>
        </form>
      </FormProvider>
      <ConfirmCaseStudyReviewModal isOpen={openModal} setIsOpen={setIsOpenModal} />
    </Stack>
  );
};

export default CaseStudyReviewForm;
